import { Component, OnInit, ViewChildren, EventEmitter, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CustomBlockAtributoComponent } from '../../../helpers/components/customAttributeBlock/customBlockAttribute.component';
import { AlertService, GrowlType } from '../../../infrastructure/services/alert.service';
import { ChannelsService } from 'app/infrastructure/services/channels.service';
import { ItemGeneralListado } from 'app/helpers/components/itemClasses/itemListadoGeneral.class';
import { UsuariosService, VariableCircuitoIn } from 'app/infrastructure/services/usuarios.service';
import { RolesService } from 'app/infrastructure/services/roles.service';
import { Translator } from 'angular-translator';
import { UserRoles } from 'app/infrastructure/model/classes/role.class';
import { UserRolesRequest } from 'app/infrastructure/model/interfaces/role.interfaces';

@Component({
  selector: 'app-roles-by-user',
  templateUrl: 'roles.by.user.component.html'
})

export class RolesByUserComponent implements OnInit {

  systemCode: string;

  businesses: ItemGeneralListado[];
  businessCode: string;
  userId: string;
  user: VariableCircuitoIn;
  selectedUser: string;
  userRoles: UserRoles;
  selectedRole: string;

  @Input() updateRoles: EventEmitter<any>;

  constructor(private aRoute: ActivatedRoute,
              private userSrv: UsuariosService,
              private roleSrv: RolesService,
              private alertService: AlertService) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.systemCode = params['codsistema'];
      this.userId = params['id'];    
      if(this.systemCode==undefined)
        this.systemCode = "null";
    this.businessChange(this.aRoute.snapshot.params.codnegocio)
    this.updateRoles.subscribe(_ => this.update());
    });
  }

  resetUsers() {
    this.user = undefined;
    this.selectedUser = undefined;
    this.resetRoles();
  }

  businessChange(newBusiness: string) {
    if(newBusiness==undefined)
      newBusiness ="null";
    this.businessCode = newBusiness;
    if (newBusiness) {
        this.resetUsers();
        this.userSrv.getUserList(this.systemCode, newBusiness).then(users => {
        this.user = users.find(x => x.codigo == this.userId);
        this.userChange(this.user.codigo);
      });
    }
  }

  resetRoles() {
    this.userRoles = undefined;
    this.selectedRole = undefined;
  }

  userChange(newUser: string) {
    this.selectedUser = newUser;
    if (newUser) {
      this.roleSrv.getRolesByUser(this.systemCode, this.businessCode, newUser)
                  .then(userRoles => {
                    this.userRoles = userRoles;
                    this.selectedRole = undefined;
                  });
    }
  }

  addRole(roleCode: string) {
      this.userRoles.activeRoles[roleCode] = true;
  }

  removeRole(roleCode: string) {
      this.userRoles.activeRoles[roleCode] = false;
  }

  update() {
    const roleCodesToSend = this.userRoles.roles
      .map(r => r.roleCode)
      .filter(rc => this.userRoles.activeRoles[rc]);
    const req = {
      adminUser: this.userRoles.adminUserName,
      userId: this.selectedUser,
      roleCodes: roleCodesToSend
    } as UserRolesRequest;

    this.roleSrv.updateUserRoles(this.systemCode, this.businessCode, req)
                .then(_ => {
                  this.alertService.showGrowl({
                    body: 'SUCCESS_USER_ROLE_SAVE',
                    type: GrowlType.SUCCESS,
                  });
                })
                .catch(reason => {
                  this.alertService.showGrowl({
                    body: reason,
                    type: GrowlType.DANGER,
                  });
                });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/usersAndProfiles/user-roles/roles.by.user.component.ts